import type { ConflitoIgnorarDialogProps } from "./types-conflito-ignorar-dialog";
import { useConflitoIgnorarDialog } from "./use-conflito-ignorar-dialog";
import { ConflitoIgnorarDialogView } from "./view-conflito-ignorar-dialog";

/** Modal "Ignorar Conflito de Alocação" dos fluxos de profissional, local e fornecedor. */
export function ConflitoIgnorarDialog(props: ConflitoIgnorarDialogProps) {
  const vm = useConflitoIgnorarDialog(props);

  return <ConflitoIgnorarDialogView {...vm} />;
}

export type * from "./types-conflito-ignorar-dialog";
